import { render, staticRenderFns } from "./edit-stockorder.vue?vue&type=template&id=5e9751d4"
import script from "./edit-stockorder.vue?vue&type=script&lang=ts"
export * from "./edit-stockorder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports